"use strict";
/**
 * Helpers of the page Bridge of the platform and of the local Bridge of the
 * StreamKit. Both runtimes embed each function as its source text
 * (`toString()`), so each stays self-contained: no imports, no names from
 * outside its own body.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAppBaseCapabilityQuery = normalizeAppBaseCapabilityQuery;
exports.appBaseRoutePatternMatches = appBaseRoutePatternMatches;
exports.createAppBaseAttachmentForm = createAppBaseAttachmentForm;
/** A capability query from a capability id or a query object; `options` win. */
function normalizeAppBaseCapabilityQuery(capabilityOrQuery, options = {}) {
    return typeof capabilityOrQuery === 'string'
        ? { ...options, capabilityId: capabilityOrQuery }
        : { ...(capabilityOrQuery || {}), ...options };
}
/**
 * Whether a page at `requestedRoute` is one of the pages a declared route
 * names: equal segments, `:name` for any segment and `:me` for the segment
 * `me` (the viewer's own row) only.
 */
function appBaseRoutePatternMatches(declaredRoute, requestedRoute) {
    const normalize = (routePath) => {
        const parts = String(routePath || '/')
            .replace(/\\/g, '/')
            .split('/')
            .filter(Boolean);
        return parts.length === 0 ? '/' : '/' + parts.join('/');
    };
    const declared = normalize(declaredRoute);
    const requested = normalize(requestedRoute);
    if (declared === requested)
        return true;
    const declaredSegments = declared.split('/').filter(Boolean);
    const requestedSegments = requested.split('/').filter(Boolean);
    if (declaredSegments.length !== requestedSegments.length)
        return false;
    return declaredSegments.every((segment, index) => segment === ':me'
        ? requestedSegments[index] === 'me'
        : segment.startsWith(':')
            ? segment.length > 1 && requestedSegments[index]
            : segment === requestedSegments[index]);
}
/**
 * The form a page sends a file in to a file action: the metadata (the
 * payload of the page, then the request, the row and the consent, given
 * unless the page says no) and the file.
 */
function createAppBaseAttachmentForm(blob, filename, command) {
    const form = new FormData();
    form.append('metadata', JSON.stringify({
        ...(command.payload &&
            typeof command.payload === 'object' &&
            !Array.isArray(command.payload)
            ? command.payload
            : {}),
        requestId: command.requestId,
        rowId: command.rowId,
        consent: command.consent ?? true,
    }));
    form.append('file', blob, filename);
    return form;
}
